<template>
  <div class="card-item p-3">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h3 class="title">Oda Tipleri</h3>
      <a @click="createRoom" href="javascript:void(0)" class="theme-btn theme-btn-small"><i class="la la-plus mr-1"></i>Yeni Oda Tipi Yarat</a>
    </div>

    <div class="table-form table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th scope="col">Kodu</th>
          <th scope="col">Adı</th>
          <th>Resim</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="room in organizedRoomList" v-bind:key="room.id">
          <td>{{ room.code }} </td>
          <td>{{ room.name }} </td>
          <td>
            <big-image-component v-if="room.imageUrl != null" :url="room.imageUrl"></big-image-component>
          </td>
          <td class="row mt-auto">
            <div class="table-content mr-2" v-on:click="deleteRoom(room)">
              <a href="javascript:void(0)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                <i class="la la-trash"></i>
              </a>
            </div>
            <div class="table-content" @click="showRoomDetail(room)">
              <a href="javascript:void(0)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit"><i class="la la-edit"></i></a>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="section-block mb-4"></div>

  </div>
</template>

<script>
import BigImageComponent from "../../common/BigImageComponent";
import messagePopupManager from "../../../util/messagePopupManager";

export default {
  name: "RoomList",
  components: {BigImageComponent},
  computed:{
    roomList:{
      get(){
        return this.$store.getters.getRoomList;
      }
    },
    organizedRoomList:{
      get(){
        let roomList = this.$store.getters.getRoomList
        if(roomList == null){
          return null;
        }
        return roomList.sort((a, b) => {
          return (a.order > b.order) ? 1 : -1
        });
      }
    }
  },
  methods:{
    showRoomDetail(room){
      let editRoom = JSON.parse(JSON.stringify(room));

      this.$store.commit("setRoom", editRoom)
      $("#roomPopup").modal('show')
    },
    createRoom(){
      $("#roomPopup").modal('show')
      this.$store.commit("setRoom",{id:null})
    },
    deleteRoom(room){
      messagePopupManager.showDeleteQuestion(() => {
        this.$store.dispatch("deleteRoom",room);
      })
    }
  },
  // beforeCreate() {
  //   this.$store.dispatch("loadCruise").then(()=>{
  //     this.$store.dispatch("loadRoomList")
  //   });
  // }
}
</script>

<style scoped>

</style>